//默认行数据
import {isEmpty} from "@/tools/utils";

const DEFAULT_ROW={
    FQuotation:'',//报价单ID
    FEntryId:'',//行ID
    FMaterialName:'',//物料名称
    FModel:'',//规格型号
    FBrand:'',//品牌
    FMLFB:'',//订货号
    FDateDelivery:'',//交货日期
    FQty:0,//数量
    FTaxListPrice:'',//列表价(含税)
    FTaxFate:'13',//税率(%)
    FListPrice:'',//面价(未税)
    FStandardDiscount:0,//标准下浮(%)
    FSpecialDiscount:0,//特殊下浮(%)
    FDiscount:0,//实际下浮(%)
    FTaxPrice:'',//实际含税单价
    FPrice:'',//实际未税单价
    FTaxAmount:'',//实际含税金额
    FTaxDeduction:'',//含税下浮额
    FAmount:'',//实际未税金额
    FDeduction:'',//未税下浮额
    FCostDiscount:'',//核算成本折扣(%)
    FAssessProfit:'',//核算利润
    FProfitRate:0,//核算利润率
    FNotes:'',//备注
    // FStatus:'',//数据状态
    FCreateUser:'',//创建者ID
    FCreateDatetime:'',//创建时间
    FUpdateUser:'',//更新者ID
    FUpdateDatetime:'',//更新时间
}

const DEFAULT_NOVAlUE_ROW = {
    FQuotation:'',//报价单ID
    FEntryId:'',//行ID
    FMaterialName:'',//物料名称
    FModel:'',//规格型号
    FBrand:'',//品牌
    FMLFB:'',//订货号
    FDateDelivery:'',//交货日期
    FQty:'',//数量
    FTaxListPrice:'',//列表价(含税)
    FTaxFate:'',//税率(%)
    FListPrice:'',//面价(未税)
    FStandardDiscount:'',//标准下浮(%)
    FSpecialDiscount:'',//特殊下浮(%)
    FDiscount:'',//实际下浮(%)
    FTaxPrice:'',//实际含税单价
    FPrice:'',//实际未税单价
    FTaxAmount:'',//实际含税金额
    FTaxDeduction:'',//含税下浮额
    FAmount:'',//实际未税金额
    FDeduction:'',//未税下浮额
    FCostDiscount:'',//核算成本折扣(%)
    FAssessProfit:'',//核算利润
    FProfitRate:'',//核算利润率
    FNotes:'',//备注
    // FStatus:'',//数据状态
    FCreateUser:'',//创建者ID
    FCreateDatetime:'',//创建时间
    FUpdateUser:'',//更新者ID
    FUpdateDatetime:'',//更新时间
    FActualDiscount:'',//实际折扣
}

function changeCell (state,data,{stateName,tableCode}){
    let editRow = state[stateName][tableCode].data[data.props.rowIndex];
    if( ['FListPrice','FMLFB'].includes(data.props.col.field) && isEmpty(editRow['FTaxFate'])){
        editRow['FTaxFate'] = 13;
    }
    if(['FQty','FListPrice','FPrice','FTaxPrice'].includes(data.props.col.field)){//数量，价格精度四位，金额，折扣精度两位
        editRow[data.props.col.field] = isNaN(Number(data.value)) ? 0.0000 : Number(data.value).toFixed(4);
    }else if(['FStandardDiscount','FSpecialDiscount','FDiscount','FAmount','FTaxAmount'].includes(data.props.col.field)){
        editRow[data.props.col.field] = isNaN(Number(data.value)) ? 0.00 : Number(data.value).toFixed(2);
    }else{
        editRow[data.props.col.field] = data.value;
    }
    if(['FListPrice'].includes(data.props.col.field)){//面价(含税)=面价(含税)*((100+税率(%)/100))
        let FListPrice =editRow['FListPrice'];
        if(FListPrice!=''){
            editRow['FTaxListPrice'] = (FListPrice*1.13).toFixed(4)
        }else{
            editRow['FTaxListPrice'] = 0.0000;
        }
    }
    if(['FListPrice','FStandardDiscount','FSpecialDiscount'].includes(data.props.col.field)){//计算 实际下浮=100-{[(100-标准下浮)/100*(100-特殊下浮)/100]*100}
        let standardDiscount = editRow['FStandardDiscount'];
        let specialDiscount = editRow['FSpecialDiscount'];
        if(standardDiscount == ''){
            standardDiscount = 0
        }
        if(specialDiscount == ''){
            specialDiscount = 0
        }
        let standardNum = (100-standardDiscount)/100;
        let specialNum =(100-specialDiscount)/100;
        editRow['FDiscount'] =(100-(standardNum*specialNum*100)).toFixed(2)
    }
    if(['FListPrice','FStandardDiscount','FSpecialDiscount','taxListPrice'].includes(data.props.col.field)){
        let FDiscount = editRow['FDiscount'];
        if(isNaN(Number(FDiscount))){
            FDiscount = 0;
        }
        let taxListPrice =editRow['FTaxListPrice'];
        if(taxListPrice!=''){//实际含税单价=面价(含税)*(100-实际下浮(%))/100
            let discountNum = 100 - FDiscount
            editRow['FTaxPrice'] = (taxListPrice * discountNum/100).toFixed(4)
        }else{
            editRow['FTaxPrice'] = 0.0000;
        }
        let taxPrice=editRow['FTaxPrice'];
        if(taxPrice != ''){//实际未税单价=实际含税单价/(100+税率(%)/100)
            editRow['FPrice'] = (taxPrice/1.13).toFixed(4);
        }else{
            editRow['FPrice'] = 0.0000;
        }
    }
    if(['FListPrice','FStandardDiscount','FSpecialDiscount','taxListPrice','FQty'].includes(data.props.col.field)){
        let FQty = editRow['FQty'];
        let taxPrice = editRow['FTaxPrice'];
        let taxListPrice= editRow['FTaxListPrice'];
        let listPrice = editRow['FListPrice'];
        if(FQty!='' && taxPrice!=''){//实际含税金额=实际含税单价*数量
            editRow['FTaxAmount'] = (taxPrice*FQty).toFixed(2);
        }else{
            editRow['FTaxAmount'] = 0.00;
        }
        let FDiscount = editRow['FDiscount'];
        if(FQty!='' && taxListPrice!=''){//含税下浮额=面价(含税)*数量*(100-实际下浮(%))/100
            let taxAmount = taxListPrice*FQty;
            let discountNum = (100-FDiscount)/100;
            editRow['FTaxDeduction'] =(taxAmount*discountNum).toFixed(2);
        }else{
            editRow['FTaxDeduction'] = 0.00;
        }

        let FPrice = editRow['FPrice'];
        if(FQty!='' && FPrice!=''){//实际未税金额=实际未税单价*数量
            editRow['FAmount'] = (FPrice*FQty).toFixed(2);
        }else{
            editRow['FAmount'] = 0.00;
        }
        if(FQty!='' && listPrice!=''){//未税下浮额=面价(未税)*数量*(100-实际下浮(%))/100
            let priceNum = listPrice*FQty;
            let discountNum = (100-FDiscount)/100;
            editRow['FDeduction'] =(priceNum*discountNum).toFixed(2);
        }else{
            editRow['FDeduction'] = 0.00;
        }
    }
    if(['FListPrice','FStandardDiscount','FSpecialDiscount','taxListPrice','FQty','FCostDiscount'].includes(data.props.col.field)){
        let taxDeduction = editRow['FTaxDeduction'];
        if(isNaN(Number(taxDeduction))){
            taxDeduction = 100;
        }
        let taxPistPrice = editRow['FTaxListPrice'];
        let FQty = editRow['FQty'];
        let costDiscount = editRow['FCostDiscount'];
        //核算利润=面价(含税)*数量*(100-实际下浮(%))/100 - 面价(含税)*数量*(100-核算成本折扣(%))/100
        if(!isNaN(Number(taxDeduction)) && !isNaN(Number(taxPistPrice)) && !isNaN(Number(FQty)) && !isNaN(Number(costDiscount))){
            let costDiscountNum = (100 - costDiscount)/100;
            let lastNumber = taxPistPrice*FQty*costDiscountNum
            editRow['FAssessProfit'] =(taxDeduction - lastNumber).toFixed(2)
        }else{
            editRow['FAssessProfit'] = 0.00;
        }

        let assessProfit = editRow['FAssessProfit'];
        let taxAmount = editRow['FTaxAmount'];
        if(!isNaN(Number(assessProfit)) && !isNaN(Number(taxAmount))){
            let sumNumer = (assessProfit/taxAmount*100).toFixed(2);
            editRow['FProfitRate'] = isNaN(sumNumer) ? 0 : sumNumer;
        }else{
            editRow['FProfitRate']=0.00;
        }
    }

    if(!isEmpty(editRow['FTaxListPrice']) && !isEmpty(editRow['FTaxPrice'])){
        let FActualDiscount = editRow['FTaxPrice'] / editRow['FTaxListPrice'];
        editRow['FActualDiscount'] =isNaN((FActualDiscount).toFixed(3)) ? 0.00 : (FActualDiscount).toFixed(3);
    }else{
        editRow['FActualDiscount'] = 0.000;
    }

}
// 反算
function oppositeCount(params,rowData){
    let query = {};
    query.FPrice = countFPrice(params,rowData);
    query.FTaxPrice = countTaxFPrice(params,rowData);
    query.FAmount = countFAmount(params,rowData);
    query.FTaxAmount = countFTaxAmount(params,rowData);
    query = {
        ...countDiscount(query.FPrice,rowData),
        ...query
    }
    query = {
        ...countFTaxDeduction(query,rowData),
        ...query
    }
    return query;
}
//计算实际 未税单价
function countFPrice(params,rowData){
    let priceData = 0;
    if(params.props.col.field == 'FPrice'){
        priceData = Number(params.value);
    }else if(params.props.col.field == 'FTaxPrice'){
        priceData = (Number(params.value) / 1.13);
    }else if(params.props.col.field == 'FAmount'){
        priceData = (Number(params.value) / Number(rowData['FQty']));
    }else if(params.props.col.field == 'FTaxAmount'){
        let FPrice = Number(params.value) / Number(rowData['FQty']);
        priceData = (Number(FPrice) / 1.13);
    }
    return priceData.toFixed(4);
}
//计算实际 含税单价
function countTaxFPrice(params,rowData){
    let taxFPrice = 0 ;
    if(params.props.col.field == 'FPrice'){
        taxFPrice = (Number(params.value)*1.13);
    }else if(params.props.col.field == 'FTaxPrice'){
        taxFPrice = Number(params.value);
    }else if(params.props.col.field == 'FAmount'){
        taxFPrice = (Number(params.value) / Number(rowData['FQty']))*1.13;
    }else if(params.props.col.field == 'FTaxAmount'){
        taxFPrice = Number(params.value) / Number(rowData['FQty']);
    }
    return taxFPrice.toFixed(4);
}
//计算实际 未税金额
function countFAmount(params,rowData){
    let amount = 0 ;
    let qty = isEmpty(rowData['FQty']) ? 0.00 : Number(rowData['FQty']);
    if(params.props.col.field == 'FPrice'){
        amount = (Number(params.value)* qty);
    }else if(params.props.col.field == 'FTaxPrice'){
        amount = (Number(params.value)/1.13)*qty;
    }else if(params.props.col.field == 'FAmount'){
        amount = Number(params.value);
    }else if(params.props.col.field == 'FTaxAmount'){
        amount = Number(params.value)/1.13;
    }
    return amount.toFixed(2);
}
//计算实际 含税金额
function countFTaxAmount(params,rowData){
    let FTaxAmount = 0 ;
    let qty = isEmpty(rowData['FQty']) ? 0.00 : Number(rowData['FQty']);
    if(params.props.col.field == 'FPrice'){
        FTaxAmount = (Number(params.value)*1.13* qty);
    }else if(params.props.col.field == 'FTaxPrice'){
        FTaxAmount = (Number(params.value))*qty;
    }else if(params.props.col.field == 'FAmount'){
        FTaxAmount = Number(params.value)*1.13;
    }else if(params.props.col.field == 'FTaxAmount'){
        FTaxAmount = Number(params.value);
    }
    return FTaxAmount.toFixed(2);
}
//实际折扣 特殊折扣 计算
function countDiscount(priceData,rowData){
    //标准折扣
    let standardDiscount = !isEmpty(rowData['FStandardDiscount']) ? Number(rowData['FStandardDiscount']) : 0;
    //实际折扣
    let FDiscount = (100-(Number(priceData)/Number(rowData['FListPrice'])*100)).toFixed(2);
    //特殊折扣
    let FSpecialDiscount = ((1-(100-FDiscount)/(100-standardDiscount))*100).toFixed(2);
    return {
        FDiscount,
        FSpecialDiscount
    }
}
/**
 * 核算利润 计算
 * 核算利润=面价(含税)*数量*(100-实际下浮(%))/100 - 面价(含税)*数量*(100-核算成本折扣(%))/100
 */
function countFTaxDeduction(query,rowData){
    let params = {};
    let taxPistPrice =  Number(rowData['FTaxListPrice']);//面价含税
    let qty = isEmpty(rowData['FQty']) ? 0 : Number(rowData['FQty']);//数量
    let discount = Number(query.FDiscount);//实际下浮
    let costDiscount = Number(rowData['FCostDiscount']);//核算成本折扣
    if(!isEmpty(taxPistPrice) && !isEmpty(qty) && !isEmpty(discount) && !isEmpty(costDiscount)){
        params['FAssessProfit'] = (taxPistPrice*qty*((100-discount)/100) - taxPistPrice*qty*((100-costDiscount)/100)).toFixed(2);
    }else{
        params['FAssessProfit'] = 0.00;
    }
    //核算利润率
    let assessProfit = params['FAssessProfit'];
    let taxAmount = !isEmpty(query['FTaxAmount']) ? Number(query['FTaxAmount']) : 0.00;
    if(!isEmpty(assessProfit) && !isEmpty(taxAmount)){
        let sumNumer = (assessProfit/taxAmount*100).toFixed(2);
        params['FProfitRate'] = isNaN(sumNumer) ? 0 : sumNumer;
    }else{
        params['FProfitRate']=0.00;
    }
    if(!isEmpty(taxAmount) && params['FAssessProfit'] != 0.00){
        params['FGrossProfitRate'] = ((params['FAssessProfit'] / taxAmount)*100).toFixed(2);
    }else{
        params['FGrossProfitRate'] =0.00;
    }
    return params
}
export {
    DEFAULT_ROW,
    DEFAULT_NOVAlUE_ROW,
    changeCell,
    oppositeCount
}
